'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};

var InputField = function InputField(_a) {
    var className = _a.className,
        onChange = _a.onChange,
        onKeyDown = _a.onKeyDown,
        onRef = _a.onRef,
        placeholder = _a.placeholder,
        error = _a.error,
        id = _a.id,
        type = _a.type,
        value = _a.value,
        name = _a.name,
        readonly = _a.readonly,
        disabled = _a.disabled,
        insetLeft = _a.insetLeft,
        insetRight = _a.insetRight,
        isAffix = _a.isAffix,
        rest = __rest(_a, ["className", "onChange", "onKeyDown", "onRef", "placeholder", "error", "id", "type", "value", "name", "readonly", "disabled", "insetLeft", "insetRight", "isAffix"]);

    var handleChange = function handleChange(e) {
        e.preventDefault();
        if (onChange) {
            onChange(e);
        }
    };
    return _react2.default.createElement("input", Object.assign({ onChange: handleChange, onKeyDown: onKeyDown, className: (0, _classnames2.default)('luna-input', className), placeholder: placeholder, "aria-describedby": error ? 'inputFeedbackText-' + id : null, name: name, id: id, type: type, value: value, readOnly: readonly, disabled: disabled, ref: onRef }, rest));
};
InputField.propTypes = {
    className: _propTypes2.default.string.isRequired,
    onChange: _propTypes2.default.func.isRequired,
    onKeyDown: _propTypes2.default.func.isRequired,
    onRef: _propTypes2.default.func.isRequired,
    placeholder: _propTypes2.default.string.isRequired,
    error: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
    id: _propTypes2.default.string.isRequired,
    type: _propTypes2.default.string,
    value: _propTypes2.default.string.isRequired,
    name: _propTypes2.default.string.isRequired,
    readonly: _propTypes2.default.bool.isRequired,
    disabled: _propTypes2.default.bool.isRequired,
    insetLeft: _propTypes2.default.node.isRequired,
    insetRight: _propTypes2.default.node.isRequired,
    isAffix: _propTypes2.default.bool.isRequired
};
InputField.defaultProps = {
    error: false,
    type: 'text'
};
exports.default = InputField;
//# sourceMappingURL=InputField.js.map